<script lang="ts">
	import type { SvelteComponent } from 'svelte'
	import { createEventDispatcher } from 'svelte'
	import { get_current_component } from 'svelte/internal'
	import type { IconSource } from 'svelte-hero-icons'
	import { Icon } from 'svelte-hero-icons'

	import { goto } from '$app/navigation'
    import { UserModuleEnabledSync } from '$lib/stores/user/manager'
	import { user_store } from '$lib/stores/user/user'	

	import ViewSubItemsIcon from './Icons/ViewSubItemsIcon.svelte'

	const dispatch = createEventDispatcher()
	const thisComponent = get_current_component()

	export let module = ''
	export let id = ''
	export let iconComponent: typeof SvelteComponent | undefined = undefined
	export let iconSource: IconSource | undefined = undefined
	export let icon = ''
	export let iconClass = ''
	export let iconSolid = false
	export let text = ''
	export let action = ''
	export let target = '_self'

	export let isSelected = false
	export let hasSubItems = false
	export let menuExpanded = false
	// export let isNew = false
	export let label = ''
	// export let newIconPos: 'left' | 'right' | 'inline' = 'right'

	let display = false
	let myId = id !== '' ? id : text
	let hasAction = action !== ''
	let textMarginLeft = '54px'
	if (!hasIcon()) {
		textMarginLeft = '32px'
	}

	// $user_store, 
	// $: display = permissionEnabled(module)

	// $: console.log('wss module reactive:', $account_role_permissions_store, $user_store)
	$: display = UserModuleEnabledSync(module, $user_store)
	
	// onMount(async () => {
	// 	await InitUser()
	// })

	function hasIcon() {
		if (iconComponent === undefined && iconSource === undefined && icon === '') return false
		return true
	}
	function toggleExpanded(): void {
		//menuExpanded = !menuExpanded;
		if (menuExpanded) collapse()
		else expand()
	}

	export function expand() {
		// console.log('MenuItem-expand', thisComponent);
		menuExpanded = true
		dispatch('expanded', thisComponent)
	}
	export function collapse() {
		// console.log('MenuItem-collapse', thisComponent);
		menuExpanded = false
	}

	function doAction(event: Event) {
		// console.log('MenuItem-doAction', event);
		if (hasSubItems && !hasAction) {
			event.preventDefault()
			event.stopPropagation()
			toggleExpanded()
		} else {
			//--- Check if the target is on another window
			if (target === '_self') {
				//--- Cancel the propagation of the Event, since it handles it here
				event.preventDefault()

				// Check if you have any action set,
				// otherwise fire the Event
				if (hasAction) {
					goto(action)
				} else {
					/* dispatch('click', { myId }); */
					dispatch('click', myId)
				}
			}
		}
	}

	function handleExpand(event: Event) {
		event.preventDefault()
		event.stopPropagation()
		toggleExpanded()
	}
</script>

<!-- 
{#await module !== '' ? UserModuleEnabled(module) : true}
{:then display} 
-->
    {#if display}
        <a href={action} {target} on:click={(e) => doAction(e)} {...$$restProps}>
            <div
			class="menu-item relative"
			class:menu-item-selected={isSelected}
			class:menu-item-expanded={menuExpanded}
			>
				<!-- {#if isNew}
					<span class={newItemIconClass}><NewItemIcon /></span>
				{/if} -->
				{#if label.length > 0}
					<div class="grid place-items-center">
						<div
							class="absolute top-3 right-5 p-1 px-2 bg-emerald-600 rounded-md text-xs font-semibold text-white transform -translate-y-1/2 whitespace-nowrap"
						>
							{label}
						</div>
					</div>
				{/if}		
				<div class="align-middle flex place-items-center">
					<!-- <div class=" inline-block align-middle"> -->
					{#if hasIcon()}
						<div class="menu-item-icon">
							{#if iconComponent !== undefined}
								<svelte:component this={iconComponent} class={iconClass} />
							{:else if iconSource !== undefined}
								<Icon src={iconSource} solid={iconSolid} class="flex-shrink-0 w-5 h-5 {iconClass}" />
							{:else}
								<img src="/menu/{icon}" alt={text} class={iconClass} />
							{/if}
						</div>
					{/if}
					<div class="menu-item-text" style="--marginLeft: {textMarginLeft};">
						<div>{text}</div>
					</div>
					{#if hasSubItems}
						<div class="menu-item-right">
							<button on:click={(e) => handleExpand(e)}>
								<div class="menu-item-right-icon">
									<ViewSubItemsIcon showSubItems={menuExpanded} />
								</div>
							</button>
						</div>
					{/if}
					<!-- </div> -->
				</div>
			</div>
		</a>
		{#if menuExpanded}
			<slot />
		{/if}
    {/if}
<!-- {/await} -->

<style lang="postcss">
	/*
	.newItem
	{
		@apply relative top-[-5px];
		@apply left-36;
	}
	*/
	.newItem-Left {
		@apply inline-block fixed;
		/* mt-[-4px]; */
		left: 48px !important;
	}
	.newItem-Right {
		@apply inline-block fixed mt-[-4px];
		right: 20px !important;
	}
	.newItem-Inline {
		@apply inline-block fixed mt-[24px];
		right: 20px !important;
	}

	.menu-item {
		/* min-height: 64px; */
		@apply h-14;
	}
	.menu-item-row {
		/* @apply relative m-0 mb-0.5; */
		/* @apply h-12; */
		/* @apply h-12 min-h-fit; */
		/* min-height: 48px;
		 @apply my-2; */
	}
	.menu-item-icon {
		@apply inline-block fixed w-5 h-5;
		@apply left-4;
	}
	.menu-item-text {
		@apply inline-block fixed;
		left: var(--marginLeft);
	}
	.menu-item-right {
		@apply inline-block fixed;
		/* @apply left-44; */
		/* left: 80%; */
		right: 20px !important;
	}
	.menu-item-right-icon {
		@apply flex w-5 h-5;
	}

	.menu-item {
		/* @apply mt-px; */
		@apply text-white;
		@apply py-0 flex cursor-pointer;
	}
	.menu-item:hover {
		@apply bg-gray-700;
	}
	.menu-item-selected {
		@apply bg-gray-600 text-emerald-200 font-medium flex cursor-pointer;
	}

	.menu-item-expanded,
	.menu-item-expanded:hover {
		@apply text-emerald-100;
		/* @apply bg-gray-600; */
	}

	.menu-item-expanded .menu-item-right {
		/* @apply text-emerald-100; */
	}
	/* @media (min-width: 768px) {
		.menu-item-right{
			left: 170px;
		}
	} */
</style>
